module.exports = __webpack_public_path__ + "static/media/kristianschmidt.e9552d3f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/kristianschmidt.webp
// module id = 817
// module chunks = 0